<template lang="pug">
  include /mixins
  +b.participant-document-view(
  )
    +e.content--hovered(@click.prevent='openPdf')
      +e.preview
        +e.img.IMG(
          :src='iconSrc'
          v-if='!item.err && iconSrc'
        )
        +b.mask-img--pointer.LABEL(
          :class="{'mask-img--with-bg': item.err}"
        )
          +e.item.IMG(
            v-if='item.err'
            src='/static/img/error.svg'
          )
      +e.name.P {{ name }}
    +e.close(@click='removeItem(idx)')
      +e.icon.mdi.mdi-close

</template>
<script>

const EXTENTIONS_MAP = {
  'application/pdf': 'PDF',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOC',
  'text/plain': 'TXT',
  'application/msword': 'DOC',
  'application/rtf': 'RTL',
  'application/vnd.oasis.opendocument.text': 'ODT',
}

const EXTENSION_CAPTIONS_MAP = {
  pdf: 'PDF',
  doc: 'DOC',
  docx: 'DOC',
  txt: 'TXT',
  rtf: 'RTL',
  odt: 'ODT',
}

export default {
  name: 'PdfViewer',
  props: {
    extentions: {
      type: Array,
      default: () => [],
    },
    item: Object,
    idx: Number,
    filekey: { default: 'img' },
    canDelete: { type: Boolean, default: true },
  },
  data() {
    return {
    }
  },
  computed: {
    url() {
      const value = this.item[this.filekey] || this.item.file || this.item.img
      return 'string' === typeof value ? value : ''
    },
    name() {
      return (this.item.file && this.item.file.name) || this.item.title || ''
    },
    caption() {
      if (this.item.type && EXTENTIONS_MAP[this.item.type]) {
        return EXTENTIONS_MAP[this.item.type]
      }
      const source = (this.item.file && this.item.file.name) || this.url || this.item.title || ''
      const matched = String(source).split('?')[0].match(/\.([a-z0-9]+)$/i)
      return matched ? EXTENSION_CAPTIONS_MAP[matched[1].toLowerCase()] : null
    },
    icon() {
      return this.getIcon()
    },
    iconSrc() {
      const { icon } = this
      if (!icon) return ''
      return (icon.props && icon.props.icon) || icon.icon || ''
    },
  },
  methods: {
    getIcon() {
      const extentions = this.extentions || []
      const isDefault = e => !!((e.props && e.props.is_default) || e.is_default)
      return extentions.find(e => this.caption && e.caption === this.caption) ||
        extentions.find(isDefault)
    },
    removeItem(idx) {
      this.$emit('removeItem', idx)
    },
    openPdf() {
      if (!this.url) return
      window.open(this.url, '_blank');
    },
  },
}
</script>
